import { getLendingDetails, getLendingList } from '@/services/lending';
import { queryKeys } from '@/types/lending';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';

export const useGetLendingList = () => {
  const [searchParams] = useSearchParams();
  const params = searchParams.toString();

  const { data, isPending, isSuccess } = useQuery({
    queryKey: [queryKeys.list, params],
    queryFn: () => getLendingList(params),
  });

  return {
    isSuccess,
    loanRequests: data?.records || [],
    isLoanRequestsPending: isPending,
    totalRecordCount: data?.totalRecordCount || 0,
  };
};

export const useGetLendingDetails = (uuid: string) => {
  const { data, isPending } = useQuery({
    queryKey: [queryKeys.details, uuid],
    queryFn: () => getLendingDetails(uuid),
  });

  return {
    loanRequest: data,
    isLoanRequestPending: isPending,
  };
};
